const CA = 'https://customer-assets-jai6qajn.emergentagent.net/job_76c777d1-11b9-4899-8be6-0aa56b6fa5a1/artifacts';

export const IMAGES = {
  may2022: `${CA}/v61hbboe_Just%20Be%20May%202022.webp`,
  july2022: `${CA}/t6rm83at_July%202022.webp`,
  aug2022: `${CA}/6vlwcm3v_just%20be%20Aug%202022.webp`,
  oct2022: `${CA}/c85urzlv_Just%20be%20oct%202022.webp`,
  southAfrica2022: `${CA}/sa3zlv2a_Just%20Be%20South%20Africa%20Nov%202022.webp`,
  novMastermind2022: `${CA}/sc9niuin_November%2011%202022%20thru%2012%20mastermind.JPG`,
  may2023: `${CA}/j7mvdfhl_just%20be%20may%202023.webp`,
  aug2023: `${CA}/g50rxfa6_just%20be%20aug%202023.webp`,
  may2024: `${CA}/ehbmhzt1_Just%20be%20may%202024.webp`,
  may2025: `${CA}/60wwsbdk_just%20be%20may%202025.webp`,
  pavilionCircle: `${CA}/p9iml1b5_DSC00149.JPG`,
  loungeTalk: `${CA}/dakgmrq2_DSC00110.JPG`,
  charterArrival: `${CA}/3x6hklgc_DSC00077.JPG`,
  charterWalk: `${CA}/09jmfo2c_IMG_1758.webp`,
  arrivalJoy: `${CA}/w889mr6i_IMG_1767.webp`,
  costaRica2026: `${CA}/tdsukg47_just%20be%20june%202026.webp`,
  sisterhood: `${CA}/ctrp7sts_IMG_1852.webp`,
  gathering: 'https://i.ontraport.com/260712.726717efdfdf89ec33f8e110c365b47c.PNG',
  culinary: `${CA}/o6hylvhn_IMG_1968%202.webp`,
  dayInLife: `${CA}/1ekfpefx_IMG_1869.webp`,
  costaRica1: 'https://i.ontraport.com/260712.155544a5758d1d35b09cacdf90ad353f.PNG',
  costaRica2: 'https://i.ontraport.com/260712.24d51fd5238aaff0d1e8dc4705bba054.PNG',
  costaRica3: 'https://i.ontraport.com/260712.e8246cf334e8430fccff91d4d75d391c.PNG',
  costaRica4: `${CA}/yfvfq13e_IMG_1853.webp`,
  sacredMoment: `${CA}/c13z5zha_IMG_1898.webp`,
  crystalAndNicole: 'https://customer-assets.emergentagent.com/job_volition-membership/artifacts/wdy6rj8w_crystal%20and%20drnicole.png',
};

export const RETREAT_YEARS = [
  {
    year: '2022',
    theme: 'Where Just Be Began',
    description: 'What started as one intimate gathering in Aruba became a movement — three island retreats, a journey to South Africa, and the first Mystery Mastermind experiences, all in a single year.',
    coverImage: IMAGES.may2022,
    events: [
      { date: 'May 5–8', title: 'Just Be Retreat', location: 'Aruba', image: IMAGES.may2022 },
      { date: 'July', title: 'Sister Diamonds Mystery Mastermind', location: 'Atlanta', image: IMAGES.july2022 },
      { date: 'August 18–21', title: 'Just Be Retreat', location: 'Aruba', image: IMAGES.aug2022 },
      { date: 'October', title: 'Just Be Retreat', location: 'Aruba', image: IMAGES.oct2022 },
      { date: 'November', title: 'Just Be', location: 'South Africa', image: IMAGES.southAfrica2022 },
      { date: 'November 11–12', title: 'Sister Diamonds Collective Mystery Mastermind', location: 'Atlanta', image: IMAGES.novMastermind2022 },
    ],
  },
  {
    year: '2023',
    theme: 'The Sisterhood Deepened',
    description: 'The circle grew wider and the conversations went deeper — two Aruba retreats and the Mystery Mastermind carried the sisterhood into its second year.',
    coverImage: IMAGES.may2023,
    events: [
      { date: 'May 11–14', title: 'Just Be Retreat', location: 'Aruba', image: IMAGES.may2023 },
      { date: 'August 3–6', title: 'Just Be Retreat', location: 'Aruba', image: IMAGES.aug2023 },
      { date: '', title: 'Sister Diamonds Mystery Mastermind', location: '', image: null },
    ],
  },
  {
    year: '2024',
    theme: 'Returning to Ourselves',
    description: 'Three years in, Just Be had become a tradition — women returning to Aruba, and to themselves.',
    coverImage: IMAGES.may2024,
    events: [
      { date: 'May 9–12', title: 'Just Be Retreat', location: 'Aruba', image: IMAGES.may2024 },
    ],
  },
  {
    year: '2025',
    theme: 'Another Year of Choosing Ourselves',
    description: 'The sisterhood kept growing, and the exhale kept deepening on the island where it all began.',
    coverImage: IMAGES.may2025,
    events: [
      { date: 'May 1–4', title: 'Just Be Retreat', location: 'Aruba', image: IMAGES.may2025 },
    ],
  },
  {
    year: '2026',
    theme: 'Soft Power',
    description: 'Our boldest chapter yet — six days in the Costa Rican rainforest, where 18 women discovered the power of softness.',
    coverImage: IMAGES.costaRica2026,
    events: [
      { date: 'June 26 – July 1', title: 'Just Be: Soft Power™ Retreat', location: 'Imiloa Institute, Costa Rica', image: IMAGES.costaRica2026 },
    ],
  },
];

export const PILLARS = [
  { key: 'arrive', title: 'Arrive', text: 'Step away from the roles, demands, and expectations you carry every day.' },
  { key: 'release', title: 'Release', text: 'Make space for what you no longer need to carry.' },
  { key: 'reconnect', title: 'Reconnect', text: 'Hear yourself. Hear God. Remember what matters.' },
  { key: 'receive', title: 'Receive', text: 'Allow yourself to be supported, witnessed, nurtured, and poured into.' },
  { key: 'return', title: 'Return', text: 'Go home differently, with clarity about what you are ready to choose next.' },
];

export const PHOTO_WALL = [
  IMAGES.sisterhood,
  IMAGES.may2022,
  IMAGES.sacredMoment,
  IMAGES.charterArrival,
  IMAGES.gathering,
  IMAGES.aug2023,
  IMAGES.loungeTalk,
  IMAGES.southAfrica2022,
  IMAGES.costaRica2026,
  IMAGES.may2024,
  IMAGES.arrivalJoy,
  IMAGES.may2025,
  IMAGES.costaRica4,
  IMAGES.pavilionCircle,
  IMAGES.culinary,
  IMAGES.oct2022,
  IMAGES.may2023,
  IMAGES.dayInLife,
  IMAGES.aug2022,
  IMAGES.charterWalk,
  IMAGES.novMastermind2022,
  IMAGES.july2022,
];

export const VIDEO_STORIES = [
  '708002728', '1082666575', '708745464', '746901729', '746901578',
  '746901352', '708002473', '708002538', '708002647', '708002791',
];

export const WRITTEN_STORY = {
  name: 'Dr. Ursula Whitehead',
  title: 'Leadership Coach',
  quote: "I am really grateful for the opportunity to work with Dr. Nicole and Crystal. They were just personal, inspiring and life-changing. If you're interested in making a change in your life and going to the next level, become a part of the Sister Diamond Collective. You will not regret it.",
};

export const EVERGREEN_FAQS = [
  {
    question: 'Who attends Sister Diamonds retreats?',
    answer: 'High-capacity women — executives, entrepreneurs, ministry leaders, caregivers, and visionaries who spend most of their lives being the strong one for everyone else. Our sisters come from every industry and every season of life, but they share one thing: they are ready to be poured into instead of poured from.',
  },
  {
    question: 'Can I come by myself?',
    answer: "Absolutely — most women do. You will arrive as a solo traveler and leave with sisters. Our retreats are intentionally intimate, and connection happens quickly when women are given permission to show up as themselves.",
  },
  {
    question: 'Do I need to be a member of Sister Diamonds?',
    answer: 'No. Just Be™ retreats are open to any woman who feels called to the experience. Many attendees discover the wider Sister Diamonds community through a retreat — but membership is never a requirement.',
  },
  {
    question: 'Are retreats only for Black women?',
    answer: 'Sister Diamonds was created to center and celebrate Black women, and our retreats reflect that heart. Every woman who honors and resonates with that mission is welcome in the space.',
  },
  {
    question: 'What makes a Sister Diamonds retreat different from a vacation or wellness retreat?',
    answer: "A vacation changes your location. A Just Be™ retreat changes your relationship with yourself. Every experience is intentionally designed around transformation — sacred conversations, guided sessions with Crystal and Dr. Nicole, sisterhood circles, ritual, rest, and space to hear God. You do not come to escape your life. You come to return to it differently.",
  },
  {
    question: 'What can I expect during a Just Be retreat?',
    answer: 'Every destination is different, but the architecture is the same: you Arrive and step out of your roles, Release what you no longer need to carry, Reconnect with yourself and with God, Receive support and sisterhood, and Return home with clarity. Expect nourishing meals, beautiful accommodations, guided sessions, plenty of unscheduled rest, laughter, tears, and breakthrough moments.',
  },
  {
    question: 'Are Sister Diamonds retreats religious?',
    answer: 'Our retreats are faith-rooted — God is welcomed and honored in the space — but they are not dogmatic or denominational. Women of all faith journeys attend and feel at home. What we hold sacred is the space itself: honest, judgment-free, and safe.',
  },
  {
    question: 'How often are retreats offered?',
    answer: 'We have hosted at least one signature Just Be™ experience every year since 2022 — sometimes several. Because our retreats are intentionally intimate, spots are limited and are announced to the priority list first.',
  },
  {
    question: 'How much do retreats typically cost?',
    answer: 'Investment varies by destination and accommodation, but recent experiences have ranged from roughly $4,000 to $7,000 for an all-inclusive, multi-day luxury experience. Pricing for each retreat is published when registration opens.',
  },
  {
    question: 'Are payment plans available?',
    answer: 'Yes. Most retreats offer a deposit plus installment options so you can reserve your spot and spread the investment over several months. Details are shared with each retreat announcement.',
  },
  {
    question: 'How can I be notified about the next retreat?',
    answer: 'Join the Retreat Priority List at the bottom of this page. Priority list members are the first to learn the destination, dates, and early registration opportunities — before anything is announced publicly.',
  },
];
